// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"f1ff3082","787":"4dc135a2"}[chunkId] + ".chunk.js";
};